/**
 * Class description
 *
 * Created: 2019-08-13
 * @author jonas
 */

import {ParsedGameData} from "@nolimitcity/slot-game/bin/core/server/data/ParsedGameData";
import {ParsedServerData} from "@nolimitcity/slot-game/bin/core/server/data/ParsedServerData";
import {GameConfig} from "@nolimitcity/slot-game/bin/core/gameconfig/GameConfig";
import {Reels} from "@nolimitcity/slot-game/bin/core/reel/reelarea/Reels";
import {IBetLineWinData} from "@nolimitcity/slot-game/bin/core/server/data/IServerData";
import {Timeline, TimelineLite} from "gsap";
import {GameRoundPresentation} from "@nolimitcity/slot-game/bin/timelinegameround/core/gameround/GameRoundPresentation";
import {SymbolUtil} from "../utils/SymbolUtil";
import {StateMatrix} from "../utils/StateMatrix";
import {ISymbolStateConfig, StateReelSymbol} from "@nolimitcity/slot-game/bin/core/reelsymbol/StateReelSymbol";
import {HarlequinParsedGameData} from "../server/data/HarlequinParsedGameData";
import {HarlequinGameModuleConfig} from "../HarlequinGameModuleConfig";
import {HarlequinReelSymbol} from "../symbols/HarlequinReelSymbol";
import {HarlequinBackground} from "../background/HarlequinBackground";
import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import {HarlequinSoundConfig} from "../HarlequinSoundConfig";
import {HarlequinGameConfig} from "../HarlequinGameConfig";
import {Harlequin} from "../Harlequin";


export class InitialWin implements GameRoundPresentation {
    private _gameData:ParsedGameData;
    private _symbolStates:StateMatrix<string>;
    private _tl:TimelineLite;
    private _wildOverlays:boolean [] = [];
    private _winRatio:number;
    private _mode:string;

  //  public stagger:number = 0;
    //public abortStagger:number = 0;

    constructor() {
    }


    public prepare(data:ParsedServerData):void {
        const harleyData:HarlequinParsedGameData = <HarlequinParsedGameData> data;
        if(data instanceof HarlequinParsedGameData) {
            HarlequinGameModuleConfig.countUpView.calculateTextScale(0, 0.2);
            // #323
            HarlequinGameConfig.instance.WIN_BELOW_STAKE = (Harlequin.api.gameClientConfiguration.belowStakeWinRestriction && (data.singleWin <= data.playedBetValue));
        }

        this._wildOverlays = (<HarlequinParsedGameData> data).wildOverlayReels;
        this._gameData = <ParsedGameData>data;
        this._symbolStates = SymbolUtil.createSymbolStateMatrixFromBetWins(
            <IBetLineWinData[]>this._gameData.betWins!,
            GameConfig.instance.SYMBOL_STATES.noWin!.keyword,
            GameConfig.instance.SYMBOL_STATES.win!.keyword);
        this._winRatio = this._gameData.singleWin/harleyData.playedBetValue;
        this._mode = data.mode;
    }

    abort(isActive: boolean, data: HarlequinParsedGameData): Timeline | null {
        return null;
    }


    public getAnimation():TimelineLite | null {
        if(this._gameData.singleWin <= 0) {
            return null;
        }

        this._tl = new TimelineLite();
        const noWinAnimations:TimelineLite = this.getNoWinSymbolAnimations();
        const winAnimations:TimelineLite = this.getWinSymbolAnimations();

        this._tl.add([
            noWinAnimations,
            winAnimations,
            () => {
                if (!HarlequinGameConfig.instance.WIN_BELOW_STAKE) {   // #323
                    this.playWinSound();
                }
                if (this._mode === "NORMAL") {
                    (<HarlequinBackground>HarlequinGameModuleConfig.background).playBgSpine("winInitial")
                }
            } ]);
        //this._tl.add(() => {}, "+=0.8");

        return this._tl
    }

    private playWinSound():void {
        //console.log("WIN RATIO: " + this._winRatio);
        if(this._winRatio < 1.5) {
            SlotGame.sound.playEffect(HarlequinSoundConfig.instance.WIN_TINY);
        }
        else if(this._winRatio < 3) {
            SlotGame.sound.playEffect(HarlequinSoundConfig.instance.WIN_SMALL);
        }
        else if(this._winRatio < 5) {
            SlotGame.sound.playEffect(HarlequinSoundConfig.instance.WIN_MEDIUM);
        }
        else if(this._winRatio < 15) {
            SlotGame.sound.playEffect(HarlequinSoundConfig.instance.WIN_LARGE);
        }
        else if(this._winRatio >= 15) {
            SlotGame.sound.playEffect(HarlequinSoundConfig.instance.BIG_WIN_INITIAL);
        }


    }

    private getStackSymbolNoWin(reelId:number, symbolId:number, animName:string = "WildInitialWinOnNonWiningPart"):TimelineLite {

        // TODO: Animation states
        // "WildInitialWinOnNonWiningPart"
        // "WildInitialWin"
        // "Wildidle"
        // "WildidleWinOnNonWiningPart
        // "WildtogleWinWin"
        // "WildtogleWinOnNonWiningPart"


        const tl:TimelineLite = new TimelineLite();
        const symbol:HarlequinReelSymbol | null = <HarlequinReelSymbol> Reels.getSymbol(reelId, symbolId);
        if(symbol) {
            /*const symbolAnimation:Timeline = symbol.changeState({
                state : state,
                setStack : true,
                fadeInDuration : 0.0
            })!;*/

            tl.add([
                () => this.sortSymbolDepthToTop(symbol),
                () => {
                    // Change to walker view
                    HarlequinGameModuleConfig.harlequinWalkerView.playWildWinSpine("WildInitialWinOnNonWiningPart", reelId, symbolId,undefined, undefined, undefined, true);
                }
            ]);
        }
        return tl;
    }

    private getStackSymbolWin(reelId:number, symbolId:number, animName:string = "WildInitialWin"):TimelineLite {

        //debugger;
        // TODO: Animation states
        // "WildInitialWinOnNonWiningPart"
        // "WildInitialWin"
        // "Wildidle"
        // "WildidleWinOnNonWiningPart
        // "WildtogleWinWin"
        // "WildtogleWinOnNonWiningPart"


        const tl:TimelineLite = new TimelineLite();
        const symbol:HarlequinReelSymbol | null = <HarlequinReelSymbol> Reels.getSymbol(reelId, symbolId);
        if(symbol) {
            /*const symbolAnimation:Timeline = symbol.changeState({
                state : state,
                setStack : true,
                fadeInDuration : 0.0
            })!;*/

            tl.add([
                () => this.sortSymbolDepthToTop(symbol),
                () => {
                    // Change to walker view
                    HarlequinGameModuleConfig.harlequinWalkerView.playWildWinSpine("WildInitialWin", reelId, symbolId, false);
                    //symbol.playNoWinWildStack(animName);
                }
            ]);
        }
        return tl;
    }


    public getNoWinSymbolAnimations():TimelineLite {
        const tl:TimelineLite = new TimelineLite();

        for(let reelId = 0; reelId < 5; reelId++) {
            const reelCoords:[number, number][] = this._symbolStates.getCoordinatesWithStateInReel(reelId, GameConfig.instance.SYMBOL_STATES.noWin!.keyword);
            //console.log("reelCoords for reelId: " + reelId);
            //console.log(reelCoords);
            for(let coords of reelCoords) {

                // TODO: add special case WLD NO WIN ANIM, !wildOverLayReels
                if(this._wildOverlays[reelId]) {
                    //console.log("coords for reelId: " + reelId);
                    //console.log(coords);
                    tl.add(() => this.getStackSymbolNoWin(coords[0], coords[1]));
                }

                tl.add(this.getSymbolAnimation(coords[0], coords[1], GameConfig.instance.SYMBOL_STATES.noWin!), 0);

            }
        }

        return tl;
    }

    public getWinSymbolAnimations():TimelineLite {
        const tl:TimelineLite = new TimelineLite();

        for(let reelId = 0; reelId < 5; reelId++) {
            const reelCoords:[number, number][] = this._symbolStates.getCoordinatesWithStateInReel(reelId, GameConfig.instance.SYMBOL_STATES.win!.keyword);
            const reelTL:TimelineLite = new TimelineLite();
            for(let coords of reelCoords) {

                // TODO: add special case WILD WIN ANIM
                if(this._wildOverlays[reelId]) {
                    //console.log("coords for reelId: " + reelId);
                    //console.log(coords);
                    tl.add(() => this.getStackSymbolWin(coords[0], coords[1]));
                }
                if (!HarlequinGameConfig.instance.WIN_BELOW_STAKE) { // #323
                    reelTL.add(this.getSymbolAnimation(coords[0], coords[1], GameConfig.instance.SYMBOL_STATES.win), 0);
                }
            }
            const position: number = HarlequinGameConfig.instance.WIN_BELOW_STAKE ? 0: reelId * 0.1; // #323
            tl.add(reelTL, position);
        }

        return tl;
    }

    private getSymbolAnimation(reelId:number, symbolId:number, state:ISymbolStateConfig):TimelineLite {
        const tl:TimelineLite = new TimelineLite();
        const symbol:StateReelSymbol | null = Reels.getSymbol(reelId, symbolId);
        if(symbol) {

            if(state.keyword === GameConfig.instance.SYMBOL_STATES.noWin!.keyword && symbol.symName === "S" && (this._mode === "NORMAL" || this._mode === "WILD_RESPIN")
                && this._gameData.nextMode === "FREESPIN") {
                tl.add([
                    () => this.sortSymbolDepthToTop(symbol)
                ]);
            }
            else {
                const symbolAnimation:Timeline = symbol.changeState({
                    state : state,
                    setStack : true,
                    fadeInDuration : 0.0
                })!;

                tl.add([
                    () => this.sortSymbolDepthToTop(symbol),
                    symbolAnimation
                ]);
            }
        }
        return tl;
    }

    protected sortSymbolDepthToTop(symbol:StateReelSymbol):void {
        if(symbol && symbol.parent) {
            symbol.parent.addChild(symbol);
        }
    }


}